import VideoPlayer, {
  VideoPlayerProps,
} from '../components/video-player/video-player';
import { render } from 'react-dom';

export const createVideoPlayer = (
  src: string,
  onPlayerReady: VideoPlayerProps['onPlayerReady'],
  onPlay: VideoPlayerProps['onPlay'],
  onPause: VideoPlayerProps['onPause'],
): HTMLDivElement => {
  const container = document.createElement('div');
  render(
    <VideoPlayer
      onPlay={onPlay}
      onPause={onPause}
      onPlayerReady={onPlayerReady}
      isAudio={false}
      media={{ url: src }}
    />,
    container,
  );
  return container;
};

export const toPx = (num: number) => `${num}px`;

export const moveVideoToPopOut = (
  videoContainer: HTMLElement,
  popOutContainer: HTMLDivElement,
  sourceContainer: HTMLElement,
) => {
  // Prevent the view from shifing when the view is removed
  // by fixing the width and height
  const { width, height } = sourceContainer.getBoundingClientRect();
  sourceContainer.style.width = toPx(width);
  sourceContainer.style.height = toPx(height);

  popOutContainer.appendChild(videoContainer);
};

export const moveVideoToOriginalContainer = (
  videoContainer: HTMLElement,
  sourceContainer: HTMLElement,
) => {
  sourceContainer.appendChild(videoContainer);
  sourceContainer.style.width = '';
  sourceContainer.style.height = '';
};
